<div class="wheel-time-picker" [class.disabled]="disabled">
  <div style="background-color: #f2f2f2; width: 85px; height: 30px; border-radius: 15px; position: absolute; top: 0; bottom: 0; left: 0; right: 0; margin: auto;"> </div>
  <!-- Hours Column -->
  <div
    class="wheel-column wheel-column--hours"
    #hoursColumn
    (pointerdown)="onPointerDown($event, hoursColumn, 'hour')"
    (pointermove)="onPointerMove($event, hoursColumn)"
    (pointerup)="onPointerUp($event, hoursColumn, 'hour')"
    (pointercancel)="onPointerCancel($event, hoursColumn, 'hour')"
    (wheel)="onWheel($event, hoursColumn, 'hour')"
  >
    <div class="wheel-fade wheel-fade-top"></div>
    <div class="wheel-fade wheel-fade-bottom"></div>
    <div class="wheel-highlight"></div>
    <div class="wheel-items">
      <div
        *ngFor="let hour of hours"
        class="wheel-item"
        [class.wheel-item-selected]="isSelectedHour(hour)"
      >
        {{ hour }}
      </div>
    </div>
  </div>

  <!-- Static Separator Column (6 colons, matching item rows) -->
  <div class="wheel-separator">
    <span class="wheel-separator-colon">:</span>
    <span class="wheel-separator-colon">:</span>
    <span class="wheel-separator-colon wheel-separator-colon--center">:</span>
    <span class="wheel-separator-colon">:</span>
    <span class="wheel-separator-colon">:</span>
  </div>

  <!-- Minutes Column -->
  <div
    class="wheel-column wheel-column--minutes"
    #minutesColumn
    (pointerdown)="onPointerDown($event, minutesColumn, 'minute')"
    (pointermove)="onPointerMove($event, minutesColumn)"
    (pointerup)="onPointerUp($event, minutesColumn, 'minute')"
    (pointercancel)="onPointerCancel($event, minutesColumn, 'minute')"
    (wheel)="onWheel($event, minutesColumn, 'minute')"
  >
    <div class="wheel-fade wheel-fade-top"></div>
    <div class="wheel-fade wheel-fade-bottom"></div>
    <div class="wheel-highlight"></div>
    <div class="wheel-items">
      <div
        *ngFor="let minute of minutes"
        class="wheel-item"
        [class.wheel-item-selected]="isSelectedMinute(minute)"
      >
        {{ minute }}
      </div>
    </div>
  </div>
</div>
